import * as React from 'react';

import BioSection from './BioSection';
import Footer from '../../components/Footer';
import FlexZone from './FlexZone';
import { click } from '../../models/didClick';

class About extends React.Component {
  componentDidMount() {
    click();
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <BioSection />
        <FlexZone />
        <Footer peach />
      </>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/scenes/About/index.tsx